import { BlaestProduct } from "@/formatters/types";

export const calculateDiscountPercentage = (
  original: number,
  current: number,
): number => {
  const difference = original - current;
  const proportion = difference / original;
  const percentage = Math.round(proportion * 100);

  return percentage;
};

export const formatPrices = (product: BlaestProduct) => {
  const pricelists: {
    pricelistId: string | undefined;
    price: string;
    priceAsNumber: number;
    priceBeforeDiscount: string;
    priceBeforeDiscountAsNumber: number;
    discountPercent: number;
    productOnSale: boolean | null;
    currency?: string | undefined;
  }[] = Object.entries(product?.prices ?? {}).map((price) => {
    const currency = price?.[1].price
      ? price?.[1].price.match(/[a-zA-Z]+$/)?.[0]
      : undefined;

    return {
      pricelistId: price?.[0],
      price: price?.[1]?.price ?? "",
      priceAsNumber: price?.[1]?.priceAsNumber ?? 0,
      priceBeforeDiscount: price?.[1]?.priceBeforeDiscount ?? "",
      priceBeforeDiscountAsNumber: price?.[1]?.priceBeforeDiscountAsNumber ?? 0,
      discountPercent: calculateDiscountPercentage(
        price?.[1]?.priceBeforeDiscountAsNumber ?? 0,
        price?.[1]?.priceAsNumber ?? 0,
      ),
      productOnSale: !!price?.[1]?.showAsOnSale,
      currency,
    };
  });

  return pricelists;
};
